<template>
    <div>
        <div class="hirings text-neutral-600 pb-4 mb-5 last:mb-0 border-b-[1px] border-neutral-200 last:border-b-0" v-for="vehicle in allVehicles" :key="vehicle.vehicle_id">
            <!-- Hiring Exists -->
            <HiringExistsDashboard :vehicle="vehicle" v-if="vehicle.hiring" />
            
            <!-- Not Hiring Exists -->
            <HiringNotExistsDashboard :vehicle="vehicle" :all-plans="allPlans" v-else />
        </div>

        <p v-show="hasItems" class="total-order text-end text-lg mt-5">Total da contratação: <b>{{ getTotalPrice(totalOrder) }}</b></p>

        <div v-if="loading" class="grid cols-1 gap-2">
          <Skeleton class="!h-28"/>
          <Skeleton class="!h-28"/>
          <Skeleton class="!h-28"/>
        </div>
    </div>
</template>

<script>
import vehiclesService from '@/services/vehiclesService'
import hiringsService from '@/services/hiringsService'
import plansService from '@/services/plansService'
import dateService from '@/services/dateService'
import { cartStore } from '@/store/cartStore'
import stringService from '@/services/stringService'
import HiringExistsDashboard from './HiringExistsDashboard.vue'
import HiringNotExistsDashboard from './HiringNotExistsDashboard.vue'

export default {
    name: "Hirings Customer Dashboard",
    components: {
        HiringExistsDashboard,
        HiringNotExistsDashboard
    },
    data() {
        return {
          allVehicles: null,
          allHirings: null,
          allPlans: null,
          loading: false,
        }
    },
    computed: {
        totalOrder() {
            return cartStore().getTotal
        },
        hasItems() {
            return cartStore().hasItems
        }
    },
    methods: {
        getTotalPrice(price) {
            return stringService.formatPrice(price)
        },
        hiringDaysLeft(datetime) {
            const now = Date.now()
            return dateService.differenceInDays(now, datetime)
        },
        async getAllVehicles() {
            try {
                const all = await vehiclesService.getAll()
                this.allVehicles = all.data
            } catch (error) {
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Erro ao carregar veículos', 
                    detail: 'Ocorreu um erro ao carregar seus veículos. Por favor, tente novamente mais tarde.' 
                })
            }
        },
        async getAllHirings() {
            const all = await hiringsService.getAll()

            if (!all) {
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Erro ao carregar contratações', 
                    detail: 'Ocorreu um erro ao carregar suas contratações. Por favor, tente novamente mais tarde.' 
                })
                return false
            }

            let hiringsStatus = []
            all.data.map((index) => {
                hiringsStatus.push({
                    status: index.hiring_status,
                    date: index.hiring_end
                })
            })

            hiringsStatus.map((index) => {
                if (index.status === 1 && this.hiringDaysLeft(index.date) < 0) {
                    this.$toast.add({ 
                        severity: 'error', 
                        summary: 'Erro ao carregar contratações', 
                        detail: 'Ocorreu um erro ao carregar suas contratações. Por favor, tente novamente mais tarde.' 
                    })
                }
            })

            this.allHirings = all.data
        },
        async getAllPlans() {
            const all = await plansService.getAll()

            if (!all) {
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Erro ao carregar planos', 
                    detail: 'Ocorreu um erro ao carregar seus planos. Por favor, tente novamente mais tarde.' 
                })
                return false
            }

            this.allPlans = all.data
        }
    },
    beforeMount() {
        //this.getAllHirings()
    },
    async mounted() {
      try {
        this.loading = true

        await this.getAllHirings()
        await this.getAllVehicles()
        await this.getAllPlans()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
}
</script>